class LgCountdown extends HTMLElement {
  connectedCallback() {
    this.deadline = parseInt(this.dataset.deadline, 10);
    if (!this.deadline) return;
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.deadline - Math.floor(Date.now() / 1000);
    if (remaining <= 0) {
      clearInterval(this.interval);
      this.hidden = true;
      return;
    }
    this.setUnit('days', Math.floor(remaining / 86400), false);
    this.setUnit('hours', Math.floor((remaining % 86400) / 3600), true);
    this.setUnit('minutes', Math.floor((remaining % 3600) / 60), true);
    this.setUnit('seconds', remaining % 60, true);
  }

  setUnit(name, value, pad) {
    const el = this.units[name];
    if (!el) return;
    el.textContent = pad ? String(value).padStart(2, '0') : String(value);
  }
}

if (!customElements.get('lg-countdown')) {
  customElements.define('lg-countdown', LgCountdown);
}
